var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48584 6.82861H19.3713L18.3343 18.2354C18.2126 19.5746 17.0897 20.6 15.745 20.6H9.11215C7.76742 20.6 6.64457 19.5746 6.52282 18.2354L5.48584 6.82861ZM6.79988 8.02861L7.7179 18.1268C7.78345 18.8479 8.38806 19.4 9.11215 19.4H15.745C16.4691 19.4 17.0737 18.8479 17.1393 18.1268L18.0573 8.02861H6.79988Z",
    fill: "#E34850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40002 5.00002C4.40002 4.11637 5.11637 3.40002 6.00002 3.40002H18.8572C19.7408 3.40002 20.4572 4.11637 20.4572 5.00002V6.4286C20.4572 7.31225 19.7408 8.0286 18.8572 8.0286H6.00002C5.11637 8.0286 4.40002 7.31225 4.40002 6.4286V5.00002ZM6.00002 4.60002C5.77911 4.60002 5.60002 4.77911 5.60002 5.00002V6.4286C5.60002 6.64951 5.77911 6.8286 6.00002 6.8286H18.8572C19.0781 6.8286 19.2572 6.64951 19.2572 6.4286V5.00002C19.2572 4.77911 19.0781 4.60002 18.8572 4.60002H6.00002Z",
    fill: "#E34850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2858 11.4C11.6172 11.4 11.8858 11.6687 11.8858 12V15.4286C11.8858 15.76 11.6172 16.0286 11.2858 16.0286C10.9544 16.0286 10.6858 15.76 10.6858 15.4286V12C10.6858 11.6687 10.9544 11.4 11.2858 11.4Z",
    fill: "#E34850"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5714 11.4C13.9028 11.4 14.1714 11.6687 14.1714 12V15.4286C14.1714 15.76 13.9028 16.0286 13.5714 16.0286C13.2401 16.0286 12.9714 15.76 12.9714 15.4286V12C12.9714 11.6687 13.2401 11.4 13.5714 11.4Z",
    fill: "#E34850"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7c25730fad0bc65e44128256a1d52b63.svg";
export { ForwardRef as ReactComponent };